import { Box, Tab, Tabs as MuiTabs } from '@mui/material';
import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
// import { twMerge } from 'tailwind-merge';

interface TabInfo {
  label: string;
  to: string;
  Icon?: React.ComponentType<any>;
}
type TabClasses = {
  root?: string;
  activeRoute?: string;
  lastIndex?: string;
  firstIndex?: string;
  container?: string;
};
interface TabsProps {
  tabs: TabInfo[];
  classes?: TabClasses;
  showHighLight?: boolean;
}

const Tabs = function Tabs(props: TabsProps) {
  const {
    tabs,
    classes,
    showHighLight,
  } = props;
  const location = useLocation();
  const { pathname } = location;
  const tabLength = tabs.length;
  const tabValue = tabs.find((tab) => pathname.startsWith(tab.to));
  return (
    <div>
      <Box className={classes?.container} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <MuiTabs className="w-[100%]" value={showHighLight ? tabValue?.to : undefined}>
          {tabs.map((tab: TabInfo, index) => {
            const lastIndex = tabLength === (index + 1);
            const firstIndex = index === 0;
            const { label, to, Icon } = tab;
            const currentRoute = pathname.startsWith(to);
            // const tabWidth = 100 / tabLength;
            return (
              <Tab
                value={to}
                className={
                  twMerge(
                    classes?.root,
                    currentRoute ? classes?.activeRoute : '',
                    firstIndex ? classes?.firstIndex : '',
                    lastIndex ? classes?.lastIndex : '',
                    // showHighLight ? '' : `w-[${tabWidth}%]`,
                  )
                }
                label={label}
                to={to}
                component={Link}
                icon={Icon ? <Icon /> : undefined}
                iconPosition="end"
              />
            );
          })}
        </MuiTabs>
      </Box>
      <Outlet />
    </div>
  );
};

Tabs.defaultProps = {
  classes: {
    root: 'min-h-[52px] rounded font-bold normal-case text-[14px]',
    activeRoute: 'bg-[#4D586A] text-white',
    lastIndex: 'rounded-r-3xl',
    firstIndex: 'rounded-l-3xl',
  },
  showHighLight: false,
};

Tabs.propTypes = {

};

export default Tabs;
